import { useState } from 'react';

export default function Sidebar() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [downloadEmail, setDownloadEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [downloadMessage, setDownloadMessage] = useState('');

  const relatedPosts = [
    {
      id: 1,
      title: '10 địa điểm không thể bỏ lỡ khi đến New York',
      image: 'https://public.readdy.ai/ai/img_res/4ce30f61f90054ede0fe90d7904f81cf.jpg'
    },
    {
      id: 2,
      title: 'Kinh nghiệm mua sắm tại các Outlet Mall ở Mỹ',
      image: 'https://readdy.ai/api/search-image?query=Modern%20American%20shopping%20outlet%20mall%20exterior%20with%20designer%20brand%20stores%2C%20clean%20architectural%20photography%2C%20bright%20daylight%2C%20shoppers%20with%20shopping%20bags%2C%20contemporary%20retail%20environment&width=120&height=120&seq=related-2&orientation=squarish'
    },
    {
      id: 3,
      title: 'Ẩm thực Mỹ: Những món ăn phải thử',
      image: 'https://readdy.ai/api/search-image?query=Delicious%20American%20cuisine%20food%20photography%20featuring%20burgers%20and%20classic%20dishes%2C%20appetizing%20presentation%20on%20wooden%20table%2C%20natural%20lighting%2C%20restaurant%20quality%20food%20styling%2C%20mouth-watering%20appearance&width=120&height=120&seq=related-3&orientation=squarish'
    },
    {
      id: 4,
      title: 'Hướng dẫn sử dụng phương tiện công cộng tại Mỹ',
      image: 'https://readdy.ai/api/search-image?query=American%20public%20transportation%20system%20with%20modern%20subway%20train%20and%20bus%2C%20clean%20urban%20transit%20photography%2C%20bright%20interior%20lighting%2C%20contemporary%20city%20commute%20scene%2C%20professional%20transit%20documentation&width=120&height=120&seq=related-4&orientation=squarish'
    }
  ];

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !name) return;

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('name', name);

      const response = await fetch('https://readdy.ai/api/form/d4mv9iit20jieso0q630', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setSubmitMessage('Đang chuyển hướng...');
        setEmail('');
        setName('');
        // Redirect to thank you page after successful submission
        setTimeout(() => {
          window.location.href = 'https://thankyou.phuotmy.com/';
        }, 500);
      } else {
        setSubmitMessage('Có lỗi xảy ra. Vui lòng thử lại.');
      }
    } catch (error) {
      setSubmitMessage('Có lỗi xảy ra. Vui lòng thử lại.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDownload = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!downloadEmail) return;

    setIsDownloading(true);
    setDownloadMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', downloadEmail);

      const response = await fetch('https://readdy.ai/api/form/d4mv97it20jieso0q62g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setDownloadMessage('Đang chuyển hướng...');
        setDownloadEmail('');
        // Redirect to thank you page after successful submission
        setTimeout(() => {
          window.location.href = 'https://thankyou.phuotmy.com/';
        }, 500);
      } else {
        setDownloadMessage('Có lỗi xảy ra. Vui lòng thử lại.');
      }
    } catch (error) {
      setDownloadMessage('Có lỗi xảy ra. Vui lòng thử lại.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="sticky top-20">
      {/* Download Checklist Widget */}
      <div className="bg-gradient-to-br from-slate-800 to-teal-700 rounded-xl p-7 text-white mb-6">
        <div className="w-14 h-14 flex items-center justify-center mb-4">
          <i className="ri-file-pdf-line text-5xl text-white"></i>
        </div>
        
        <h3 className="text-lg font-bold mb-4">
          Tải miễn phí Checklist du lịch Mỹ
        </h3>
        
        <div className="space-y-2 mb-5">
          <div className="flex items-start gap-2">
            <i className="ri-check-line text-teal-300 text-lg mt-0.5"></i>
            <span className="text-sm text-white/90">Danh sách giấy tờ cần thiết</span>
          </div>
          <div className="flex items-start gap-2">
            <i className="ri-check-line text-teal-300 text-lg mt-0.5"></i>
            <span className="text-sm text-white/90">Checklist đồ dùng hành lý</span>
          </div>
          <div className="flex items-start gap-2">
            <i className="ri-check-line text-teal-300 text-lg mt-0.5"></i>
            <span className="text-sm text-white/90">Lịch trình chuẩn bị từng bước</span>
          </div>
        </div>
        
        <form onSubmit={handleDownload} data-readdy-form id="checklist-download">
          <input
            type="email"
            name="email"
            value={downloadEmail}
            onChange={(e) => setDownloadEmail(e.target.value)}
            placeholder="Email của bạn"
            required
            className="w-full px-4 py-3 rounded-lg text-gray-900 text-sm mb-3 focus:outline-none focus:ring-2 focus:ring-teal-400"
          />
          
          <button
            type="submit"
            disabled={isDownloading}
            className="w-full bg-white text-slate-800 px-6 py-3 rounded-lg text-sm font-semibold hover:bg-gray-50 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer disabled:opacity-50"
          >
            <i className="ri-download-line text-lg"></i>
            {isDownloading ? 'Đang xử lý...' : 'Tải ngay (PDF)'}
          </button>
        </form>

        {downloadMessage && (
          <div className={`mt-3 text-sm ${downloadMessage.includes('thành công') || downloadMessage.includes('gửi') ? 'text-teal-200' : 'text-red-200'}`}>
            {downloadMessage}
          </div>
        )}
      </div>

      {/* Subscription Form Widget */}
      <div className="bg-white border-2 border-teal-600 rounded-xl p-6 mb-6">
        <div className="w-12 h-12 flex items-center justify-center mb-4">
          <i className="ri-mail-line text-4xl text-teal-600"></i>
        </div>
        
        <h3 className="text-base font-bold text-gray-900 mb-4">
          Nhận hướng dẫn Visa qua email
        </h3>
        
        <form onSubmit={handleSubscribe} data-readdy-form id="visa-guide-subscription">
          <input
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Họ và tên"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm mb-3 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          />
          
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email của bạn"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm mb-3 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          />
          
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-orange-500 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
          >
            {isSubmitting ? 'Đang gửi...' : 'Đăng ký ngay'}
          </button>
        </form>

        {submitMessage && (
          <div className={`mt-3 text-sm ${submitMessage.includes('thành công') ? 'text-green-600' : 'text-red-600'}`}>
            {submitMessage}
          </div>
        )}
        
        <p className="text-xs text-gray-500 text-center mt-3">
          Miễn phí • Không spam
        </p>
      </div>

      {/* Related Posts Widget */}
      <div className="bg-gray-50 rounded-xl p-5">
        <h3 className="text-base font-bold text-gray-900 mb-4">Đọc thêm</h3>
        
        <div className="space-y-4">
          {relatedPosts.map((post, index) => (
            <div key={post.id}>
              <a href="#" className="flex gap-3 group cursor-pointer">
                <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                    {post.title}
                  </h4>
                </div>
              </a>
              {index < relatedPosts.length - 1 && (
                <div className="border-b border-gray-200 mt-4"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}